import { useTranslation } from 'react-i18next';

import { SectionStyleSegment } from '@models/PageSection';

const useStyleNames = () => {
  const { t } = useTranslation();

  const getStyleName = (styleSegment: SectionStyleSegment, full?: boolean) => {
    const prettyName = t('styleSegment', { context: styleSegment });
    return full ? `${prettyName} [${styleSegment}]` : prettyName;
  };

  return { getStyleName };
};

export default useStyleNames;
